import { graphql } from "gatsby"
import React from "react"
import loadable from '@loadable/component';
import HomeContent from "../components/organisms/home-content/home-content"
import Layout from "../shared/components/organisms/layout/layout" 
import { canIDeployOnThisCountry } from "../shared/components/molecules/update-data-campaign-2/countryInfo2"
import SEO from "../shared/seo"
import "../shared/styles/index.scss"

const ModalComponentHome = loadable(() => 
import("../components/molecules/modal-home/modal-home")
)
const UpdateDataCampaign2 = loadable(() => 
import('../shared/components/molecules/update-data-campaign-2/update-data-campaign-2')
)

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      havePoints: this.props.data.allContentfulNolPaises.nodes.filter(
        e => e.codigoIcu === process.env.LOCALE,
      )[0].tieneMisPuntos,
      news: this.props.data.nuestroMundo.nodes.filter(
        a =>
          a.seccionDelArticulo === "Nuestro Mundo" &&
          a.tipoDeArticulo !== "Video",
      ),
      femaleCare: this.props.data.femaleCare.nodes,
      videos: this.props.data.allContentfulNolHome.edges[0].node.nosotrasVideos,
      islog: false,
      ageSegment: "Anónimo",
      lanzamiento: {
        hayLanzamiento: this.props.data.allContentfulNolHome.edges[0].node
          .hayLanzamiento,
        infoLanzamiento: this.props.data.allContentfulNolHome.edges[0].node
          .productoLanzamiento,
      },
      campanas: this.props.data.allContentfulNolCampanas.edges,
    }
      }

  componentDidMount() {
    this.setState({ ageSegment: this.getAgeSegment(this.calculateAge()) })
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      this.setState({
        islog: true,
      })
    } else {
      this.setState({
        islog: false,
      })
    }

    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }

    sessionStorage.clear()

    window.addEventListener("resize", this.updateDimensions)
  }

  getArticleaByAge = items => {
    return items
      .map(art =>
        art.fields.segmentoDelArticulo.filter(
          a =>
            a.fields.nombreEtiqueta ===
            this.getAgeSegment(this.calculateAge()) ||
            a.fields.nombreEtiqueta === "Anónimo",
        ).length > 0
          ? art
          : null,
      )
      .filter(e => e !== null)
  }

  calculateAge = () => {
    if (typeof window !== "undefined") {
      if (localStorage.getItem("USER_INFO") === null) {
        return 0
      } else {
        var today = new Date()
        var birthDate = new Date(
          JSON.parse(localStorage.getItem("USER_INFO")).birthdate,
        )
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    } else {
      return 0
    }
  }

  getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return "Adolescente" //Sara
    } else if (age >= 18 && age <= 24) {
      return "Adulto Joven" //carolina
    } else if (age >= 25) {
      return "Adulto" //juliana
    } else {
      return "Anónimo"
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  render() {
        return (
      <Layout title={this.props.data.allContentfulNolHome.edges[0].node.metaTitulo} mobile={this.state.mobile}>
        <SEO
          title={this.props.data.allContentfulNolHome.edges[0].node.metaTitulo}
          description={
            this.props.data.allContentfulNolHome.edges[0].node.metaDescripcion.metaDescripcion.split("\n")[0]}
        />
          <ModalComponentHome
            campana={this.state.campanas}
            mobile={this.state.mobile}
            section={"home"}
          />


        <HomeContent
          havePoints={this.state.havePoints}
          femaleCare={this.state.femaleCare}
          news={this.state.news}
          contennInfo={this.props.data}
          mobile={this.state.mobile}
          lanzamiento={this.state.lanzamiento}
          videos={this.state.videos}
          islog={this.state.islog}
          ageSegment={this.state.ageSegment}
          campanas={this.state.campanas}
        />
        {canIDeployOnThisCountry &&
          <UpdateDataCampaign2 />}
        
      </Layout>
    )
  }
}

/**
 * allContentfulNolHome: Get header info
 * allContentfulBannerPrincipal: Get main banner information
 * allContentfulNavegacionSubmenu21: Title submenu 2 - 1
 * allContentfulNavegacionSubmenu22: Title submenu 2 - 2
 */
export const query = graphql`
    query GET_HOME_CONTENT($locale: String!) {
      allContentfulNolHome(filter: { node_locale: { eq: $locale } }) {
        edges {
          node {
            tieneBotonFlotante
            botonFlotante {
              imagenesDeBanner {
                file {
                  url
                }
              }
              redireccion
              tituloBanner
            }
            metaTitulo
              bannerPrincipal {
                tipoDeBanner
                redireccion
                codigoVideo
                imagenesDeBanner {
                  description
                  file {
                    url
                    details {
                      image {
                        height
                      }
                    }
                  }
                  fixed {
                    base64
                  }
                }
              }
              metaDescripcion {
                metaDescripcion
              }
              parametrosBannerPrincipal {
                tiempo_rotacion
                velocidad_rotacion
              }
              nosotrasVideos {
                title
                imagenDelPaso {
                  file {
                    url
                  }
                  description
                }
                enlaceVideo
              }
              hayLanzamiento
              productoLanzamiento {
                botonConocerProducto
                url
                imagenPc {
                  file {
                    url
                  }
                  description
                }
                imagenMobile {
                  description
                  file {
                    url
                  }
                }
                idProductoLanzamiento
              }
              nosotrasNews {
                descripcionNoticia {
                  childContentfulRichText {
                    html
                  }
                }
                url
                tituloNoticia
                imagenNoticiaMobile {
                  description
                  fluid(maxWidth: 1100, quality: 100) {
                    ...GatsbyContentfulFluid_withWebp_noBase64
                  }
                }
                imagenNoticia {
                  fluid(maxWidth: 300, quality: 100) {
                    ...GatsbyContentfulFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
        nuestroMundo: allContentfulNolArticulos(
          filter: { node_locale: { eq: $locale } ,
          seccionDelArticulo: {eq: "Nuestro Mundo"}},
          sort: { fields: fechaDePublicacion, order: DESC },
          limit: 100
        ) {
          nodes {
            fechaDePublicacion
            paisesDeRestriccionDelArticulo
            segmentoDelArticulo {
              nombreEtiqueta
            }
            seccionDelArticulo
            tipoDeArticulo
            tituloArticulo
            descripcionArticulo
            slug
            categorias {
              titulo
              slug
            }
            imagenArticuloMiniatura {
              description
              file {
                url
                details {
                  image {
                    height
                    width
                  }
                }
              }
            }
          }
        }
        femaleCare: allContentfulNolArticulos(
          filter: { node_locale: { eq: $locale } ,
          seccionDelArticulo: {eq: "Cuidado Femenino"}},
          sort: { fields: fechaDePublicacion, order: DESC },
          limit: 100
        ) {
            nodes {
              fechaDePublicacion
              paisesDeRestriccionDelArticulo
              segmentoDelArticulo {
                nombreEtiqueta
              }
              seccionDelArticulo
              tipoDeArticulo
              tituloArticulo
              descripcionArticulo
              slug
              categorias {
                titulo
                slug
              }
              imagenArticuloMiniatura {
                description
                file {
                  url
                  details {
                    image {
                      height
                      width
                    }
                  }
                }
              }
            }
          }
          allContentfulNolHome(filter: { node_locale: { eq: $locale } }) {
            nodes {
              productosDestacados {
                titulo
                slug
                categoria
                imagenSubcategoria {
                  file {
                    details {
                      image {
                        height
                      }
                    }
                    url
                  }
                  description
                  fixed {
                    base64
                  }
                }
                descripcionSubcategoria {
                  descripcionSubcategoria
                }
              }
            }
          }
          allContentfulNolConcursos(
            filter: {
              node_locale: { eq: $locale }
              titulo: { ne: "contenido-oculto" }
            }
        ) {
            nodes {
              ocultarDestacadoHome
              estadoConcurso
              titulo
              slug
              redireccionParaParticipar
              imagenHome {
                description
                file {
                    url
                }
              }
            }
          }
          allContentfulNolJuegos(
            filter: {
              node_locale: { eq: $locale }
              titulo: { ne: "contenido-oculto" }
            }
        ) {
            nodes {
              metaImagen {
                file {
                  url
                }
                description
              }
              metaTitulo
              slug
            }
          }
          allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
            nodes {
              codigoIcu
              tieneMisPuntos
              tieneVConfident
              tieneSeguimientoMuestraVConfident
            }
          }
          allContentfulNolCampanas(filter: {seccionVisualizacion: {in: "home"}}) {
            edges {
              node {
                id
                fechaFin
                idCampana
                esPermanente
                esCampanaHome
                tipoVisualizacion
                cantidadVisualizaciones
                seccionVisualizacion
                recursos {
                  id
                  imagenesDeBanner {
                    description
                    file {
                      url
                    }
                  }
                  redireccion
                  tipoDeBanner
                  codigoVideo
                }
                node_locale
                paisesDeRestriccionCampana
              }
            }
          }
        }
`

export default IndexPage
